import { InjectionToken, Provider } from '@angular/core';

import type { SimulationHistoricalDraftPort } from '~/app/domains/simulation/v2/domain/ports/simulation-historical/draft-store.port';
import { SimulationHistoricalNGXSStoreAdapter } from '~/app/domains/simulation/v2/infrastructure/simulation-historical-store.adapter';

// Tokens (1 par port runtime)
export const SIMULATION_HISTORICAL_DRAFT_PORT =
    new InjectionToken<SimulationHistoricalDraftPort<unknown>>('SIMULATION_HISTORICAL_DRAFT_PORT');

// Bindings (tous au même endroit)
export const SIMULATION_V2_PROVIDERS: Provider[] = [
    { provide: SIMULATION_HISTORICAL_DRAFT_PORT, useExisting: SimulationHistoricalNGXSStoreAdapter },
];

